// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__productList__root"};